import * as React from "react";
import { LgpkiVerifyResult } from "@graffer-inc/cloud-gov-core";
import { BaseModal } from "../../../atoms/base-modal";
import {
  SecondaryButton,
  SuccessBanner,
  WarningBanner,
} from "@graffer-inc/console-design-kit";
import { formatDatetime } from "../../../../utils/date-utils";

interface LgpkiVerifyResultModalProps {
  isActive: boolean;
  onClose: () => void;
  result?: LgpkiVerifyResult;
}

const VerifyResultSummary: React.FC<{ result?: LgpkiVerifyResult }> = ({
  result,
}) => {
  return (
    <>
      {result ? (
        <div style={{ marginBottom: "24px" }}>
          {result.isValid ? (
            <SuccessBanner message="署名は有効です" />
          ) : (
            <WarningBanner message="署名は無効です" />
          )}
        </div>
      ) : (
        <span>検証処理中です。処理が完了するまでお待ちください。</span>
      )}
    </>
  );
};

export const LgpkiVerifyResultModal: React.FC<LgpkiVerifyResultModalProps> = ({
  isActive,
  onClose,
  result,
}) => {
  return (
    <BaseModal isActive={isActive} title="LGPKI検証結果" onClose={onClose}>
      <section className="modal-card-body">
        <VerifyResultSummary result={result} />
        {/** ToDo(yo-tak): 署名の有効・無効の詳細を表示する */}
        {result && result.isValid && (
          <>
            <section style={{ marginBottom: "24px" }}>
              <h2 className="title is-size-4 section-title">
                署名者証明書情報
              </h2>
              <div className="field">
                <h3 className="label">組織名</h3>
                <span>{result.organizationName}</span>
              </div>
              <div className="field">
                <h3 className="label">都道府県域名</h3>
                <span>{result.localityName}</span>
              </div>
              <div className="field">
                <h3 className="label">地方公共団体・所属部門名</h3>
                <span>{result.organizationalUnitNames.join(" ")}</span>
              </div>
              <div className="field">
                <h3 className="label">役職名等</h3>
                <span>{result.commonName}</span>
              </div>
              <div className="field">
                <h3 className="label">有効期間</h3>
                <span>
                  {formatDatetime(result.signerCertNotBeforeUnixSecond * 1000)}
                  {" - "}
                  {formatDatetime(result.signerCertNotAfterUnixSecond * 1000)}
                </span>
              </div>
            </section>
            <section style={{ marginBottom: "24px" }}>
              <h2 className="title is-size-4 section-title">署名情報</h2>
              <div className="field">
                <h3 className="label">署名の場所</h3>
                <span>{result.location}</span>
              </div>
              <div className="field">
                <h3 className="label">理由</h3>
                <span>{result.reason}</span>
              </div>
              <div className="field">
                <h3 className="label">署名日時</h3>
                <span>{formatDatetime(result.signedAtUnixSecond * 1000)}</span>
              </div>
            </section>
          </>
        )}
      </section>
      <section className="modal-card-foot">
        <SecondaryButton
          text="閉じる"
          onClick={onClose}
          style={{ flexGrow: 1 }}
        />
      </section>
    </BaseModal>
  );
};
